import { RedirectSitemapIndex, sitemapSsrLogic } from '@components/pages/sitemap-redirects';
import { RedirectSitemapDetail, sitemapDetailsSsrLogic } from '@components/pages/sitemap-redirects/details';
import { Default as DefaultLayout } from '@components/templates/layouts/Default';
import { prerenderPaths } from '@lib/graphql/helpers/prerenderPaths';
import { decodeOptions } from '@src/utils/urlHelpers';
import type { GetStaticPaths } from 'next/types';

function Redirects({ data, slug, entry }) {
  if (slug === 'index') {
    return <RedirectSitemapIndex data={data} entry={entry} />;
  }
  return <RedirectSitemapDetail data={data} entry={entry} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: await prerenderPaths(['/sitemap-redirects/index']),
    fallback: 'blocking',
  };
};

export async function getStaticProps({ params }) {
  const options = decodeOptions(params?.slug);

  if (options.slug === 'index') {
    return await sitemapSsrLogic();
  }

  return await sitemapDetailsSsrLogic({ slug: options.slug });
}

Redirects.PageLayout = DefaultLayout;

export default Redirects;
